/* unplugin-vue-components disabled */import { render } from "./EditPasswd.vue?vue&type=template&id=640dcd0e"
import script from "./EditPasswd.vue?vue&type=script&lang=js"
export * from "./EditPasswd.vue?vue&type=script&lang=js"

import "./EditPasswd.vue?vue&type=style&index=0&id=640dcd0e&lang=css"

import exportComponent from "C:\\Users\\Administrator\\IdeaProjects\\haoma517-cust\\haoma517-customer-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__